export default "__VITE_ASSET__D2pGAE$d__"